import React from "react";
import "./payment-options.scss";
import onlineLogo from "../images/online.svg";
import phoneLogo from "../images/phone.svg";
import inPersonLogo from "../images/in-person.svg";
import vLines from "../images/lines.svg";

function PaymentOptions() {
  return (
    <section className="payment-options" id="payment-options">
      <div className="payment-options__bg-pattern"></div>
      <div className="payment-options__container">
        <img className="payment-options__v-lines" src={vLines} alt="" />
        <div className="payment-options__tabs-wrapper">
          <h2 className="heading--big">3 Simple Ways To Pay</h2>
          <div className="payment-options__grid">
            <div className="payment-options__grid-item">
              <img src={onlineLogo} alt="" />
              <p>
                Submit a one-time payment or set up automatic withdrawals to
                ensure your payment is always on time. Remember, automatic
                payments don’t include any additional fees.*
              </p>
              <a
                href="https://spectrum.accountportalonline.com/"
                className="btn--blue"
              >
                Make a Payment
              </a>
            </div>
            <div className="payment-options__grid-item">
              <img src={phoneLogo} alt="" />
              <p>
                Give us a call. We’re available Monday-Friday between 9AM and
                5PM MST and Saturdays from 10AM to 2PM MST to take payments over
                the phone.
              </p>
              <a href="tel:+18015420639" className="btn--blue">
                Call 801-542-0639
              </a>
            </div>
            <div className="payment-options__grid-item">
              <img src={inPersonLogo} alt="" />
              <p>
                Conveniently make your payment with cash or card at 7/11,
                Walmart, Walgreens, or additional locations near you.*
              </p>
              <a
                href="https://home.paynearme.com/all-locations/ "
                className="btn--blue"
              >
                Find a Location
              </a>
            </div>
          </div>
        </div>
        <p className="payment-options__sm-text">
          * One-time payments will be charged a $5.00 convenience fee by the
          third-party processor, PayNearMe. The fee will be added automatically
          to your payment amount. Sign up for automatic payments today to avoid
          paying a fee.
        </p>
      </div>
    </section>
  );
}

export default PaymentOptions;
